module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_aplus-3c513aaa37dac0f13e56f600014c3f65.png";